var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCartActive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 28,
    viewBox: "0 0 30 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 8.16663H23.4875C23.8368 8.16664 24.1822 8.23496 24.5014 8.36718C24.8207 8.49941 25.1067 8.6926 25.3411 8.93431C25.5754 9.17602 25.7529 9.46088 25.8621 9.77053C25.9713 10.0802 26.0098 10.4078 25.975 10.7321L25.225 17.7321C25.1633 18.3079 24.8746 18.8417 24.415 19.23C23.9553 19.6183 23.3575 19.8333 22.7375 19.8333H10.8C10.2218 19.8335 9.66147 19.6467 9.21431 19.3046C8.76714 18.9626 8.46082 18.4864 8.3475 17.9573L6.25 8.16663Z",
    stroke: "#538135",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 24.5H22.5M6.25 8.16667L5.2375 4.38317C5.16979 4.13088 5.01369 3.90694 4.79401 3.74693C4.57433 3.58692 4.30366 3.50001 4.025 3.5H2.5L6.25 8.16667ZM10 24.5H12.5H10Z",
    stroke: "#538135",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCartActive);
export default __webpack_public_path__ + "static/media/cart_active.28522107990d80f1a9451d9d8471ce49.svg";
export { ForwardRef as ReactComponent };